import { toast } from "react-toastify";
import { delay } from "./flow-helper";

export const toastError = (message, autoClose = 2000): Promise<unknown> => {
    toast.error(message, { autoClose });
    return delay(autoClose);
};

export const toastSuccess = (message, autoClose = 200): Promise<unknown> => {
    toast.success(message, { autoClose: 2500 });
    return delay(autoClose);
};
